import { createFileRoute, redirect } from '@tanstack/react-router';
import { SIGN_IN } from '@/lib/constants/routes';

export const Route = createFileRoute('/')({
  loader: () => {
    throw redirect({ to: SIGN_IN });
  },
});
